/**
 * ResourcesTab Component
 * Program documents and videos
 */

import React from 'react';
import { FaFileAlt, FaVideo } from 'react-icons/fa';
import styles from './TabStyles.module.css';

const ResourcesTab = ({ program }) => {
  const documents = program?.resources?.documents || [];
  const videos = program?.resources?.videos || [];

  const hasResources = documents.length > 0 || videos.length > 0;

  return (
    <div className={styles.tabContainer}>
      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Resources</h3>
        
        {!hasResources && (
          <p className={styles.emptyMessage}>No resources available.</p>
        )}

        {/* Documents */}
        {documents.length > 0 && (
          <div className={styles.resourceSection}>
            <h4 className={styles.resourceSectionTitle}>Documents</h4>
            <div className={styles.resourceList}>
              {documents.map((doc, index) => (
                <a 
                  key={index} 
                  href={doc.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.resourceItem}
                >
                  <FaFileAlt className={styles.resourceIcon} />
                  <span>{doc.name}</span>
                </a>
              ))}
            </div>
          </div>
        )}

        {/* Videos */}
        {videos.length > 0 && (
          <div className={styles.resourceSection}>
            <h4 className={styles.resourceSectionTitle}>Videos</h4>
            <div className={styles.resourceList}>
              {videos.map((video, index) => (
                <a 
                  key={index} 
                  href={video.youtubeUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.resourceItem}
                >
                  <FaVideo className={styles.resourceIcon} />
                  <span>{video.title || `Video ${index + 1}`}</span>
                </a>
              ))}
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default ResourcesTab;










